import { union } from 'io-ts/lib/Decoder';

import { Id as ClientId } from '../client/Id';
import { Id as FranchiseId } from '../franchise/Id';
import { Id as OrganizationId } from '../organization/Id';
import { Id as PrincipalId } from '../principal/Id';

export const ParentId = union(FranchiseId, OrganizationId, PrincipalId, ClientId);
